module.exports = __webpack_public_path__ + "img/2.069289ec.png";